import type { FC } from 'react';
import type { TableBodyProps } from './table.types';

export const TableBody: FC<TableBodyProps> = ({ children, ...props }) => {
  return <tbody {...props}>{children}</tbody>;
};
